<mat-dialog-content>
    <mat-card appearance="outlined" class="mat-mdc-elevation-specific mat-elevation-z8">
        <mat-card-header>
            <mat-card-title>
                Edit {{data.tableName}} Table Structure
            </mat-card-title>
        </mat-card-header>

        <div class="form-container">
            <mat-form-field style="width: 400px;">
                <mat-label>Table Description</mat-label>
                <input matInput name="tableDescription" [(ngModel)]="newDescription">
            </mat-form-field>
            <br>
            <ng-container *ngFor="let field of fields">
                <mat-form-field *ngIf="!field.removed">
                    <mat-label>Column Name</mat-label>
                    <input matInput name="{{field.newName}}" [(ngModel)]="field.newName" (keypress)="keyFilter($event)">
                    <button mat-button matSuffix color="warn" (click)="removeFieldClicked(field.newName)"><mat-icon>delete</mat-icon></button>
                </mat-form-field>
            </ng-container>
        </div>
    </mat-card>

    <table>
        <tr>
            <td style="width: 33%; text-align: left;">
                <button mat-raised-button color="accent" (click)="addField()" [disabled]="formContainsEmptyFields()">Add Column</button>
            </td>
            <td style="width: 34%; text-align: center;">
                <button mat-raised-button color="accent" [disabled]="formContainsEmptyFields() || formContainsDuplicateFields() || !didAnythingChange()" (click)="save()">Save</button>
                <button mat-raised-button color="warn" style="margin-left: 10px;" (click)="cancel()">Cancel</button>
            </td>
            <td style="width: 33%; text-align: right;">
                <span *ngIf="formContainsDuplicateFields()" style="color: red;">ERROR: There are one or more duplicate field names</span>
            </td>
        </tr>
    </table>
</mat-dialog-content>